import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import ErrorBoundary from './components/ErrorBoundary'
import { ToastProvider } from './components/Toast'
import VersionGuard from './components/VersionGuard'
import LoginPage from './pages/LoginPage'
import DashboardV5 from './pages/DashboardV5'
import OnboardingPage from './pages/OnboardingPage'
import CguPage from './pages/CguPage'
import CgvPage from './pages/CgvPage'
import PrivacyPage from './pages/PrivacyPage'
import MentionsLegalesPage from './pages/MentionsLegalesPage'
import ContactPage from './pages/ContactPage'
import FaqPage from './pages/FaqPage'

// DEV-only — harnais de preview design. Le ternaire statique (et pas un lazy
// inconditionnel) permet au tree-shaking d'ÉLIMINER le chunk du build prod.
const PreviewAccueil = import.meta.env.DEV ? lazy(() => import('./pages/_PreviewAccueil')) : null
const PreviewDossiers = import.meta.env.DEV ? lazy(() => import('./pages/_PreviewDossiers')) : null

function LoadingScreen() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-page)' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '0.75rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-muted)', fontFamily: "'JetBrains Mono', monospace" }}>
          IAvocat<span style={{ color: 'var(--accent)' }}>.ai</span> · chargement
        </div>
      </div>
    </div>
  )
}

function ProtectedApp() {
  const { user, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!user) return <Navigate to="/login" replace />
  return <DashboardV5 />
}

function ProtectedOnboarding() {
  const { user, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!user) return <Navigate to="/login" replace />
  return <OnboardingPage />
}

export default function App() {
  return (
    <ErrorBoundary>
      <VersionGuard />
      <ToastProvider>
        <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* DEV-only — harnais de preview design (données fictives, hors auth) */}
            {import.meta.env.DEV && (
              <Route path="/__preview/accueil" element={<Suspense fallback={null}><PreviewAccueil /></Suspense>} />
            )}
            {import.meta.env.DEV && (
              <Route path="/__preview/dossiers" element={<Suspense fallback={null}><PreviewDossiers /></Suspense>} />
            )}
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/cgu" element={<CguPage />} />
            <Route path="/cgv" element={<CgvPage />} />
            <Route path="/confidentialite" element={<PrivacyPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FaqPage />} />
            {/* Protected onboarding (4 steps wizard) */}
            <Route path="/onboarding" element={<ProtectedOnboarding />} />
            {/* Protected — redirige vers login si non connecté, sinon dashboard */}
            <Route path="/*" element={<ProtectedApp />} />
          </Routes>
        </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </ErrorBoundary>
  )
}
